'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageContent = function MessageContent(_ref) {
  var height = _ref.height,
      message = _ref.message,
      styles = _ref.styles,
      baseUrl = _ref.baseUrl;


  var imageContainer = function imageContainer(src) {
    var heightNeeded = (height || 0) / 3;
    return src && _react2.default.createElement(
      'div',
      { className: 'imageContainer' },
      _react2.default.createElement(
        'figure',
        null,
        _react2.default.createElement('img', { draggable: 'false', src: baseUrl + "/" + src, role: 'presentation', height: heightNeeded + 'px', className: 'image' })
      )
    );
  };

  var customStyles = {};
  message.backgroundColor ? customStyles.backgroundColor = message.backgroundColor : false;
  message.color ? customStyles.color = message.color : false;

  var src = message.showMedia ? message.showMedia.srcThumbnail : undefined;

  var messageClass = (0, _classnames2.default)({
    'contentBase': true,
    'contentRight': !message.inbound,
    'withImage': src ? true : false
  });

  return _react2.default.createElement(
    'div',
    { className: messageClass, style: customStyles },
    _react2.default.createElement(
      'span',
      { className: 'author' },
      message.author
    ),
    _react2.default.createElement('span', { className: 'text', dangerouslySetInnerHTML: { __html: message.message } }),
    imageContainer(src, height)
  );
};

MessageContent.propTypes = {
  height: _react.PropTypes.number,
  message: _react.PropTypes.shape({
    message: _react.PropTypes.string,
    src: _react.PropTypes.string,
    inbound: _react.PropTypes.bool.isRequired,
    avatar: _react.PropTypes.string,
    backgroundColor: _react.PropTypes.string,
    color: _react.PropTypes.string
  }).isRequired,
  styles: _react.PropTypes.object,
  baseUrl: _react.PropTypes.string
};

exports.default = MessageContent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/MessageContent.js
// module id = 346
// module chunks = 0